// extracted by mini-css-extract-plugin
export default {"sectionItemStyle":"UserSelectorListItem_sectionItemStyle__UWRNd","textStyle":"UserSelectorListItem_textStyle__LS+NJ"};